import React, { useEffect, useState } from "react";
import { Autocomplete, TextField} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { postResource, fetchEntityById } from "../../../../apis/apiService";
import { Box } from "@mui/system";
import { CustomNoRowsOverlay } from "../../../common/OverlayGrid";


const IssueTask = () => {
  // const [taskId, setTaskId] = useState(null);
  // const [taskName, setTaskName] = useState([]);
  const project_id = localStorage.getItem("project_id");
  const { id: issue_id } = useParams();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10,});
  const [inputValue, setInputValue] = React.useState("");
  const [projects, setProjects] = useState([
    {
      id: 1,
      task_id: null,
      task_list_name: "",
      owner: "",
      current_status_name: "",
      start_date: "",
      end_date: "",
      estimated_hours: "",
      priority_name: "",
    },
  ]); // Initial empty table with one row
  const [searchOptions, setSearchOptions] = useState([]);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log("login_user in task:", login_user);
  const { role: login_user_role } = login_user;
  // //console.log("login_user role in task:", login_user_role);

  const taskListNames = async () => {
    try {
      const response = await fetchEntityById("tasksInProjects", project_id);
      // //console.log("task list api response :", response);
      if (response) {
        const taskOptions = response.data.map((task) => {
          // //console.log("task name  :", task);

          return {
            label: task.title, // Use for Autocomplete options
            id: task.task_id, // Use for Autocomplete options
          };
        });
        // setTaskName(taskOptions);
        // //console.log("taskOptions: ", taskOptions);

        setSearchOptions(taskOptions); // Populate search options
      }
    }
    catch (err) {
      const errorMsg = err.message;
      toast.error(errorMsg);
      console.error("Error fetching task lists:", err);
    }
  };

  useEffect(() => {
    taskListNames();
  }, []);

  const handleTaskSelection = async (rowId, value) => {
    if (!value || !value.id) return;

    // //console.log("Selected Task ID:", value.id);
    // //console.log("Row ID:", rowId);

    try {
      // 🔹 Call the POST API first
      await postAssociatedTasks(value.id);
      // 🔹 Then fetch the updated task list
      await fetchAssociatedTasks();
    } 
    catch (err) {
      console.error("Error in task selection process:", err);
    }
  };

  const postAssociatedTasks = async (taskId) => {
    if (!taskId) {
      console.error("Error: task_id is missing!");
      return;
    }

    const requestedData = { task_id: taskId }; // Ensure correct format

    // //console.log("Posting Data:", requestedData);

    try {
      const response = await postResource("milestones/issue", "task/add", issue_id, requestedData);
      if (response.status) {
        toast.success(response.message);
        // //console.log("Post API Success:", response);
      } 
      else {
        toast.error("Failed to add task");
        console.error("Post API Error:", response);
      }
    } 
    catch (err) {
      toast.error("Error posting task");
      console.error("Error posting associated tasks:", err);
    }
  };

  const fetchAssociatedTasks = async () => {
    try {
      const response = await fetchEntityById("milestones/issue/task/show", issue_id);
      if (response && response.associated_tasks) {
        // //console.log("Fetched Associated Tasks:", response.associated_tasks);
        const updatedTasks = response.associated_tasks.map((task) => ({
          id: task.task_id,
          task_id: task.task_id,
          task_list_name: task.title,
          owner: task.owner || "",
          current_status_name: task.current_status_name || "",
          start_date: task.start_date || "",
          end_date: task.end_date || "",
          estimated_hours: task.estimated_hours || "",
          priority_name: task.priority_name || "",
        }));

        // Add an empty row at the end for the next entry
        updatedTasks.push({
          id: updatedTasks.length + 1,
          task_id: null,
          task_list_name: "",
          owner: "",
          current_status_name: "",
          start_date: "",
          end_date: "",
          estimated_hours: "",
          priority_name: "",
        });

        setProjects(updatedTasks);
      }
    } 
    catch (err) {
      console.error("Error fetching associated tasks:", err);
    }
  };

  useEffect(() => {
    fetchAssociatedTasks(); // Fetch associated tasks when the component loads
  }, []);

  const columns = [
    { field: "task_id", 
      headerName: "ID", 
      width: 150 
    },
    {
      field: "task_list_name",
      headerName: "Task Name",
      width: 300,
      renderCell: (params) => {
        const isLastRow = params.row.task_id === null; // Only show Autocomplete for the empty row

        return isLastRow ? (
          <Box sx={{ width: "100%", py: "7px" }}>
            <Autocomplete
              options={searchOptions}
              getOptionLabel={(option) => option.label || ""}
              filterOptions={(options, { inputValue }) =>
                inputValue
                  ? options.filter((option) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    )
                  : []
              }
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                // //console.log("onInputChange :", newInputValue);
                setInputValue(newInputValue);
              }}
              onChange={(event, value) =>
                handleTaskSelection(params.row.id, value)
              }
              open={inputValue.length > 0} // Show options only when user types
              popupIcon={null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Associate Tasks"
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
            />
          </Box>
        ) : (
          params.row.task_list_name
        );
      },
    },
    { field: "current_status_name", 
      headerName: "Status", 
      width: 150 
    },
    { field: "owner", 
      headerName: "Owner", 
      width: 150 
    },
    { field: "start_date", 
      headerName: "Start Date", 
      width: 150 
    },
    { field: "end_date", 
      headerName: "Due Date", 
      width: 150 
    },
    { field: "estimated_hours", 
      headerName: "Duration", 
      width: 150 
    },
    { field: "priority_name", 
      headerName: "Priority", width: 150 
    },
  ];

  // useEffect(() => {
  //   showAssociatedTasks();
  // }, []);

  return (
    <div style={{ width: "100%", marginTop: "10px" }}>
      {login_user_role !== "CLIENT" && (
        <Box
          sx={{
            height: projects.length === 0 ? 300 : "100%",
            width: "100%",
          }}
        >
          <DataGrid
            rows={projects}
            getRowId={(row) => row.id}
            columns={columns}
            pagination
            paginationModel={paginationModel}
            slots={{ noRowsOverlay: CustomNoRowsOverlay }}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[10, 20, 30, 40]}
            rowHeight={58}
          />
        </Box>
      )}
    </div>
  );
};

export default IssueTask;

// export default MilestoneIssuetask;
